<template>
    <div class="e-root-container">
        <div class="e-container-row">
            <el-col :span="24">
                <top-bar :user_info="userInfo"
                         :title_info="titleInfo"
                         :menu_lock.sync="menu_lock"
                         @menu_collapse_change="menuCollapseChange"
                         @user_info_item_click="userInfoItemClick"
                />
            </el-col>
        </div>
        <div class="e-container-row">
            <div class="e-menu-container">
                <menu-bar :is_collapse="menu_collapse" :current_menu="current_menu" @transition_end="menuTransitionEnd"
                          @menu_select="menuSelect"/>
            </div>
            <div class="e-page-container">
                <div class="e-page-navigation" v-if="current_menu">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <!-- 首页 -->
                        <el-breadcrumb-item :to="'/'" class="e-page-navigation-item">首页</el-breadcrumb-item>
                        <!-- 菜单路径 -->
                        <el-breadcrumb-item v-for="obj of current_menu.nav" :key="obj.id"
                                            class="e-page-navigation-item">
                            {{ obj.name }}
                        </el-breadcrumb-item>
                        <!-- 当前菜单 -->
                        <el-breadcrumb-item v-if="current_menu.append.length > 0" class="e-page-navigation-item">
                            <span class="e-current-menu" @click="backCurrentMenu">{{ current_menu.name }}</span>
                        </el-breadcrumb-item>
                        <el-breadcrumb-item v-else class="e-page-navigation-item">{{ current_menu.name }}
                        </el-breadcrumb-item>
                        <!-- 菜单子级 -->
                        <el-breadcrumb-item v-for="(obj,index) of current_menu.append" :key="'menu_append_' + index"
                                            class="e-page-navigation-item">
                            {{ obj.name }}
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <div class="e-page-body" v-if="enable_tabs">
                    <div class="tabs">
                        <el-tabs type="card" editable>
                            <el-tab-pane :key="item.name" v-for="(item) of tabs" :label="item.title" :name="item.title">
                            </el-tab-pane>
                        </el-tabs>
                        <router-view @append_path="appendPath"></router-view>
                    </div>
                </div>

                <div class="e-page-body" v-else>
                    <router-view @append_path="appendPath"></router-view>
                </div>
            </div>
        </div>

        <!-- 修改密码框 -->
        <el-dialog title="修改密码" width="600px" :visible.sync="dialogResetPasswordVisible">
            <el-form :model="passwordRuleForm" :rules="passwordRules" ref="passwordRuleForm" label-width="100px"
                     size="small" style="padding-right: 50px">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="原密码" prop="oldPassword">
                            <el-input type="password" v-model="passwordRuleForm.oldPassword"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="新密码" prop="password">
                            <el-input type="password" v-model="passwordRuleForm.password"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="确认密码" prop="affirmPassword">
                            <el-input type="password" v-model="passwordRuleForm.affirmPassword"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item>
                    <el-button type="primary" @click="submitModifyPassword()">确认</el-button>
                    <el-button @click="closeModifyPassword()">关闭</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

    </div>

</template>

<script>

import MenuBar from '@/views/layout/components/menu-bar'
import TopBar from '@/views/layout/components/top-bar'
import {mapState, mapActions} from 'vuex'
import {getUserInfo} from "@/utils/user-info-store"
import {logout} from "@/apis/core/login"
import {modifyPassword} from "@/apis/system/user"

export default {
    name: 'Index',

    components: {
        MenuBar, TopBar
    },

    data() {
        return {
            enable_tabs: false,
            menu_lock: true,
            menu_collapse: false,
            body_width: 24,
            tabs: [],
            current_menu: null,
            userInfo: {},
            titleInfo: {},

            dialogResetPasswordVisible: false,
            passwordRuleForm: {},
            passwordRules: {
                oldPassword: [
                    {required: true, message: '请输入原密码', trigger: 'blur'},
                ],
                password: [
                    {required: true, message: '请输入新密码', trigger: 'blur'},
                ],
                affirmPassword: [
                    {required: true, message: '请再次输入密码', trigger: 'blur'},
                    {
                        validator: (rule, value, callback) => {
                            console.log("test:" + (value !== this.passwordRuleForm.password));
                            if (value !== this.passwordRuleForm.password) {
                                callback(new Error());
                            } else {
                                callback();
                            }
                        }, message: '两次输入密码不一致', trigger: 'blur'
                    },
                ]
            },
        }
    },

    computed: {
        ...mapState({
            vuexData: state => state.layout
        })
    },

    mounted() {
        let vuexData = this.vuexData;
        if (vuexData) {
            for (let key in vuexData) {
                this[key] = vuexData[key];
            }
        }
        this.userInfo = getUserInfo();
        this.titleInfo = {
            name: "安保能业务管理平台"
        };
    },

    methods: {
        ...mapActions([
            "vuexSetLayout"
        ]),

        /**
         * 菜单折叠改变
         *
         * @param collapse 是否折叠
         */
        menuCollapseChange(collapse) {
            if (!collapse) {
                this.body_width = 21
            }
            this.menu_collapse = collapse;

            this.vuexSetLayout(this.getLayoutData());
        },

        /**
         * 菜单动画结束
         *
         * @param collapse 是否折叠
         */
        menuTransitionEnd(collapse) {
            if (collapse) {
                this.body_width = 24;
                this.vuexSetLayout(this.getLayoutData());
            }
        },

        /**
         * 菜单选择事件
         *
         * @param e 选择的菜单
         */
        menuSelect(e) {
            this.current_menu = e;
            this.$router.push({
                path: e.page
            });

            this.vuexSetLayout(this.getLayoutData());
        },

        /**
         * 菜单路径追加
         *
         * @param obj 追加的菜单
         */
        appendPath(obj) {
            if (this.current_menu === null) {
                return;
            }
            this.current_menu.append.push(obj);
        },

        /**
         * 返回当前菜单
         */
        backCurrentMenu() {
            this.current_menu.append = [];
            this.$router.push({
                path: this.current_menu.page
            });
        },

        /**
         * 用户信息操作项点击事件
         * @param command
         */
        userInfoItemClick(command) {
            switch (command) {
                case "update_password":
                    this.dialogResetPasswordVisible = true;
                    break;
                case "logout":
                    logout().then(() => {
                        this.$router.push({
                            path: "/login"
                        });
                        this.$message.success(`退出登录成功`);
                    }).catch((ex) => {
                        this.$message.error(ex.message);
                    });
                    break;
            }
        },

        /**
         * 提交修改密码
         */
        submitModifyPassword() {
            this.$refs.passwordRuleForm.validate((valid) => {
                if (!valid) {
                    return;
                }
                let obj = {
                    oldPassword: this.passwordRuleForm.oldPassword,
                    password: this.passwordRuleForm.password
                }
                modifyPassword(obj).then(() => {
                    this.$message.success(`修改成功`);
                    this.dialogResetPasswordVisible = false;
                    this.passwordRuleForm = {};
                }).catch((ex) => {
                    this.$message.error(ex.message);
                });
            });
        },

        /**
         * 关闭修改密码
         */
        closeModifyPassword() {
            this.passwordRuleForm = {};
            this.dialogResetPasswordVisible = false;
        },

        getLayoutData() {
            let data = JSON.parse(JSON.stringify(this.$data));
            delete data.dialogResetPasswordVisible;
            delete data.passwordRuleForm;
            delete data.passwordRules;
            return data;
        }

    }
}

</script>

<style scoped lang='scss'>
@import 'style.scss';
</style>

